import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const fuelLaneInvoiceStylesAdapter = getAdapter({ idFieldName: 'value' });

const fuelLaneInvoiceStylesSlice = createSlice({
  name: 'fuelLaneInvoiceStyles',
  initialState: fuelLaneInvoiceStylesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setFuelLaneInvoiceStyles: (state, { payload: { fuelLaneInvoiceStyles, source } }) => {
      fuelLaneInvoiceStylesAdapter.setAll(state, fuelLaneInvoiceStyles);
      state.source = source;
    }
  }
});

const selectors = fuelLaneInvoiceStylesAdapter.getSelectors(({ fuelLaneInvoiceStyles }) => fuelLaneInvoiceStyles);

export const getFuelLaneInvoiceStyles = state => selectors.selectAll(state);

export const { setFuelLaneInvoiceStyles } = fuelLaneInvoiceStylesSlice.actions;

export default fuelLaneInvoiceStylesSlice.reducer;
